import React from "react";
import { reportWorkflow } from "./telemetry.js";

export default class AppErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch() { reportWorkflow({ workflow: "browser", outcome: "failed", reason: "render_failed" }); }
  render() {
    if (this.state.failed) return <main role="alert" className="p-6"><h1>This page could not be displayed</h1><p>Try reloading the page. If it continues, contact support and tell them which page you were opening.</p><button onClick={() => window.location.reload()}>Reload page</button><a className="ml-4" href="/support">Contact support</a></main>;
    return this.props.children;
  }
}
